export default class DataGroupingOption {
  constructor({
    adapter,
    apiParams,
    category,
    filterObjects,
    label,
  }) {
    this.adapter = adapter;
    this.apiParams = apiParams;
    this.category = category;
    this.filterObjects = filterObjects;
    this.label = label;
  }
}
